import React from 'react'
import Heading from './Heading'
import { Grid } from '@mui/material'
import FullName from './FullName'
import Phone from './Phone'
import Email from './Email'
import Address from './Address'
import SingleChoice from './SingleChoice'
import ShortText from './ShortText'
import LongText from './LongText'

const ItemDonationForm = () => {


    const typeOfDonation = [
        {
            id: 1,
            label: "کمکهای مالی",
            checked: false
        },
        {
            id: 2,
            label: "لباس",
            checked: false
        },
        {
            id: 3,
            label: "کفش و کیف",
            checked: false
        },
        {
            id: 4,
            label: "لوازم آشپزخانه",
            checked: false
        },
        {
            id: 5,
            label: "کتاب‌ها",
            checked: false
        },
        {
            id: 6,
            label: "اسباب‌بازی و بازی‌ها",
            checked: false
        },
        {
            id: 7,
            label: "هنر",
            checked: false
        },
        {
            id: 8,
            label: "لوازم خواب و حوله",
            checked: false
        },
        {
            id: 9,
            label: "ملزومات بهداشتی",
            checked: false
        },
        {
            id: 10,
            label: "کالاهای ورزشی",
            checked: false
        },
        {
            id: 11,
            label: "مبلمان و لوازم خانه",
            checked: false
        },
    ]


    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم اهدای اقلام'} subHeader={''} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <Phone header={'شماره تلفن'}/>
                <Email header={'ایمیل'}/>
                <Address header={'آدرس'}/>
                <SingleChoice header={'نوع کمک مالی'} options={typeOfDonation}/>
                <ShortText header={'چی دوست داری اهدا کنی؟'}/>
                <LongText header={'یادداشت‌ها'}/>
            </Grid>
        </Grid>
    )
}

export default ItemDonationForm
